import React, { ReactElement } from 'react';
import { MenuItem } from '@material-ui/core';
import { Iterable } from 'immutable';

import BudgetAllocation from 'entities/budgetAllocation/model';
import DonationCreditRule from 'entities/donationCreditRule/model';
import FormSelectRedesign, { FormSelectRedesignProps } from 'retired/FormSelectRedesign';
import Budget from 'entities/budget/model';
import { formatAmount } from 'utils/format';

type BudgetSubEntitySelectorProps<S = BudgetAllocation | DonationCreditRule> = {
  fullWidth: boolean;
  budgets: Iterable<string, Budget>;
  subBudgets: Iterable<string, S>;
} & FormSelectRedesignProps;

export const BudgetSubEntitySelector: React.FC<BudgetSubEntitySelectorProps> = ({
  subBudgets,
  budgets,
  ...props
}): ReactElement => (
  <FormSelectRedesign {...props}>
    {subBudgets
      .toArray()
      .sort((a, b) => a.limitTotal - a.totalIssued - (b.limitTotal - b.totalIssued))
      .map((subEntity) => {
        const budget = budgets.get(subEntity.budget);

        if (!budget) {
          return null;
        }

        const budgetBalance = Number.isFinite(budget.limitTotal)
          ? budget.limitTotal - (budget?._matchedAmountCurrencies?.[budget?.currencyCode] ?? 0)
          : Infinity;
        const balance = Number.isFinite(subEntity.limitTotal)
          ? subEntity.limitTotal - (subEntity?.totalIssuedCurrencies?.[budget?.currencyCode] ?? 0)
          : Infinity;
        const effectiveBalance = Math.min(budgetBalance, balance);

        return (
          <MenuItem key={subEntity.id} value={subEntity.id}>
            {budget.title}/{subEntity.title} ({subEntity?.currencyCode}
            {Number.isFinite(effectiveBalance)
              ? ` ${formatAmount(effectiveBalance || 0)} remaining`
              : ` unlimited`}
            )
          </MenuItem>
        );
      })
      .filter(Boolean)}
  </FormSelectRedesign>
);
